import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade/common/pages/result-details/lang/indexTask';
let default_1 = class default_1 extends Vue {
    detailsProps;
    allConfidence = false;
    details = {};
    confidenceList = [];
    onDetails() {
        this.details = this.detailsProps;
        this.getConfidence();
    }
    getConfidence() {
        let taskAlertConfig = {};
        if (this.details.incidentType === 'INCIDENT_TRAFFIC_RETROGRADE' || this.details.incidentType === 'INCIDENT_TRAFFIC_ILLEGAL_STOP') {
            taskAlertConfig = JSON.parse(this.details.trafficAnnotation.taskAlertConfig);
        }
        else {
            taskAlertConfig = JSON.parse(this.details.commonAnnotation.taskAlertConfig);
        }
        const thresholdConfigs = taskAlertConfig.thresholdConfigs[0];
        for (let key in thresholdConfigs) {
            if (thresholdConfigs[key] && !(thresholdConfigs[key] instanceof Array) && typeof thresholdConfigs[key] !== 'string') {
                const obj = {
                    name: key,
                    content: {},
                    enable: true,
                };
                // 不显示trashBinUncoverTime,stopDurationDetectTime,enable
                if (thresholdConfigs[key].hasOwnProperty('trashBinUncoverTime')) {
                    thresholdConfigs[key]['trashBinUncoverTime'] = null;
                }
                if (thresholdConfigs[key].hasOwnProperty('stopDurationDetectTime')) {
                    thresholdConfigs[key]['stopDurationDetectTime'] = null;
                }
                if (thresholdConfigs[key].hasOwnProperty('lidUncoverDetectTime')) {
                    thresholdConfigs[key]['lidUncoverDetectTime'] = null;
                }
                if (thresholdConfigs[key].hasOwnProperty('enable')) {
                    obj.enable = thresholdConfigs[key].enable;
                    thresholdConfigs[key]['enable'] = null;
                }
                obj.content = { ...thresholdConfigs[key] };
                this.confidenceList.push(obj);
            }
        }
    }
    btnAllConfidence() {
        this.allConfidence = !this.allConfidence;
    }
};
__decorate([
    Prop()
], default_1.prototype, "detailsProps", void 0);
__decorate([
    Watch('detailsProps', { immediate: true, deep: true })
], default_1.prototype, "onDetails", null);
default_1 = __decorate([
    Component({
        name: 'details-left',
        components: {},
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
